export enum AssetGlobalApprovalTypes {
  NoApproval = 1,
  UserGroup = 2,
  FrontOffice = 3,
}

export enum AssetApprovalStatuses {
  Approved = 1,
  NotApproved = 2,
}

export enum AssetDocCategories {
  AMC = 'AMC',
  Insurance = 'INSURANCE',
  Warranty = 'WARRANTY',
  Purchase = 'PURCHASE',
  Certificate = 'CERTIFICATE',
  Other = 'OTHER',
  Commissioning = 'COMMISSIONING',
  Asset_Image = 'ASSET_IMAGE',
  User_Manual = 'USER_MANUAL',
  Maintenance_Documents = 'MAINTENANCE_DOCUMENTS',
}
